import React, { Component } from 'react';
import HeaderLogo from './HeaderLogo';
import HeaderNav from './HeaderNav';

class Header extends Component {

  _isMounted = false

  constructor(props) {
    super(props);
    this.state = {
      flag: "header",
      logoHover: false
    };
    this.onMouseEnter = this.handleHover.bind(this);
    this.onMouseLeave = this.handleLeave.bind(this);
    this.scroll = this.isInViewport.bind(this)
    this.resize = this.handleHeaderPos.bind(this)

    this.ref = React.createRef()
  }

  componentDidMount() {
		this._isMounted = true
    this.isInViewport()
		window.addEventListener( "scrollingDown", this.scroll )
    window.addEventListener( "resizingWindow", this.resize )
    this.props.trackThis( "add", "scrollingDown" )
    this.props.trackThis( "add", "resizingWindow" )
	}
	componentWillUnmount() {
		this._isMounted = false
		window.removeEventListener( "scrollingDown", this.scroll )
		window.removeEventListener( "resizingWindow", this.resize )
    this.props.trackThis( "remove", "scrollingDown" )
    this.props.trackThis( "remove", "resizingWindow" )
  }
  componentDidUpdate() {
    const headerY = this.props.state.headerY
    const currentOffsetTop = this.ref.current.offsetTop
    const same = headerY === currentOffsetTop
    if ( !same && this.props.state.heroIsActive ) this.handleHeaderPos( currentOffsetTop )
  }

  handleHeaderPos(){
    this.props.headerPos(this.ref.current.offsetTop)
  }
  
	isInViewport() {
		const tagTop = this._isMounted 
			? this.ref.current.offsetTop 
			: null
		const viewportTop = window.scrollY
		const viewportBottom = viewportTop + window.innerHeight
		if ( tagTop <= viewportBottom ) {
      // console.log("smaller", tagTop)
			// window.removeEventListener( "scroll", this.onScroll )
			// this.props.isVisible( this.props.element )
		}
	}

  handleHover() { this.setState({ logoHover: true }); }
  handleLeave() { this.setState({ logoHover: false }); }

  render() {
    // header hero logic
    const { heroIsActive } = this.props.state;
    const { headerStyle } = this.props.state;
    const isSecond = headerStyle === 'second';
    const className = heroIsActive && isSecond ? 'stick-to-second-section' : '';

    // TODO: get these bools differently
    const hasLogo = this.props.state.hasLogo
    const hasNav = Object.keys( this.props.state.headerNavItems ).length

    return (
      <header id={this.state.flag} className={className} ref={this.ref}>
        { hasLogo && (
        <HeaderLogo
          state={this.props.state}
          onClick={this.props.onClick}
          logoHover={this.state.logoHover}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        />
        ) }
        { hasNav && (
        <HeaderNav
          state={this.props.state}
          onClick={this.props.onClick}
          logoHover={this.state.logoHover}
        />
        ) }
      </header>
    );
  }
}

export default Header;
